import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";

// Only suppress browser extension errors in production
if (import.meta.env.PROD) {
  const originalError = console.error;
  console.error = (...args) => {
    const errorMessage = args[0]?.toString() || '';
    if (
      errorMessage.includes('Could not establish connection') ||
      errorMessage.includes('Receiving end does not exist') ||
      errorMessage.includes('runtime.lastError')
    ) {
      return; // Silently ignore browser extension errors
    }
    originalError.apply(console, args);
  };
}

// Add error boundary for root
try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }
  
  createRoot(rootElement).render(<App />);
} catch (error) {
  console.error("Failed to initialize app:", error);
  // Show error to user
  document.body.innerHTML = `
    <div style="padding: 50px; text-align: center; font-family: Arial, sans-serif;">
      <h1 style="color: #ef4444;">Application Error</h1>
      <p>Failed to initialize the application. Please try refreshing the page.</p>
      <p style="color: #666; font-size: 14px;">Error: ${error instanceof Error ? error.message : 'Unknown error'}</p>
      <button onclick="location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #3b82f6; color: white; border: none; border-radius: 6px; cursor: pointer;">
        Reload Page
      </button>
    </div>
  `;
}
